import { render, staticRenderFns } from "./DailyAmountShippedList.vue?vue&type=template&id=cb58e790"
import script from "./DailyAmountShippedList.vue?vue&type=script&lang=js"
export * from "./DailyAmountShippedList.vue?vue&type=script&lang=js"
import style0 from "./DailyAmountShippedList.vue?vue&type=style&index=0&id=cb58e790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports